import { Item, Toolbar } from 'devextreme-react/toolbar'
import { Button } from 'devextreme-react/button'
import { Login } from '@microsoft/mgt-react'
import './Header.scss'
import type { HeaderProps } from '@/types'
import { ThemeLightSwitcher, ThemeSizeSwitcher } from '../theme-selector/theme-selector'
import { useScreenSize } from '@/themes/media-query'
import UserCard from '@/components/UserCard/UserCard'
import { BreadCrumbs } from '../BreadCrumbs/BreadCrumbs'
import NotificationButton from '@/components/notifications/NotificationButton'
import { WhatsNewButton } from '@/components/WhatsNew/WhatsNewButton'
import { useWhatsNewStore } from '@/components/WhatsNew/WhatsNewState'
import { Popup } from 'devextreme-react'
import { WhatsNew } from '@/components/WhatsNew/WhatsNew'

export default function Header({ menuToggleEnabled, title, toggleMenu }: HeaderProps) {
  const { isXSmall, isSmall } = useScreenSize()
  const { close, isOpen, showWhatsNew } = useWhatsNewStore()

  return (
    <header className={'header-component'}>
      <Toolbar className={'header-toolbar'}>
        <Item visible={menuToggleEnabled} location={'before'} widget={'dxButton'} cssClass={'menu-button'}>
          <Button icon="menu" stylingMode="text" onClick={toggleMenu} />
        </Item>

        {isXSmall || isSmall ? (
          <Item location={'before'} cssClass={'header-title'} text={title} visible={!!title} />
        ) : (
          <Item location={'before'} cssClass={'header-breadcrumbs'}>
            <BreadCrumbs />
          </Item>
        )}
        {showWhatsNew && (
          <Item location={'after'} locateInMenu={'never'}>
            <WhatsNewButton />
          </Item>
        )}

        <Item location={'after'} locateInMenu={'never'}>
          <ThemeSizeSwitcher />
        </Item>

        <Item location={'after'} locateInMenu={'never'}>
          <ThemeLightSwitcher />
        </Item>
        {process.env.NODE_ENV !== 'production' && (
          <Item location={'after'} locateInMenu={'never'}>
            <NotificationButton />
          </Item>
        )}

        <Item location={'after'} locateInMenu={'never'}>
          <Login showPresence={true} loginView={isXSmall || isSmall ? 'avatar' : 'compact'}>
            <UserCard template={'flyout-person-details'} />
          </Login>
        </Item>
      </Toolbar>
      <Popup
        visible={isOpen}
        hideOnOutsideClick={true}
        onHiding={close}
        showTitle={false}
        maxWidth={1200}
        contentComponent={WhatsNew}
      />
    </header>
  )
}
